<template>
  <vs-popup id="popupSafetyInspectionPlan" title="시설물 안전점검 계획" :active.sync="popupActiveSync" >
    <div>
      <div class="head p-4">
        <vs-select autocomplete style="width: 80px;" v-model="search.dateType" >
          <vs-select-item text="작성일" value="작성일"/>
          <vs-select-item text="계획일" value="계획일"/>
        </vs-select>
        <search-nav-item-date label="" class="ml-2" v-model="search.date"/>
        <search-nav-item-select label="검색조건"
                                class="ml-2"
                                style="width: 200px !important;"
                                v-model="search.searchType"
                                :list="[
                                    {value: '시설물명'},
                                    {value: '소속명'},
                                    {value: '부서명'},
                                    {value: '작성자'},
                                  ]" />
        <search-nav-item-keyword class="ml-2" label="키워드" style="width: 200px !important;" v-model="search.searchKeyword" />
        <vs-button class="ml-auto" color="secondary" @click="handleSearch">검색</vs-button>
      </div>
      <div class="body">

        <vs-table stripe
                  style="overflow-y: auto;"
                  ref="table"
                  :sst="true"
                  :max-items="table.perPage"
                  :data="table.list"
                  noDataText="'데이터가 없습니다."
                  @selected="handleItemClickDetail">

          <template slot="thead">
            <vs-th class="w-1/12" style="min-width:100px" sort-key="title">No.</vs-th>
            <vs-th class="w-1/12" style="min-width:100px" sort-key="title">시설물명</vs-th>
            <vs-th class="w-1/12" style="min-width:100px" sort-key="title">소속명</vs-th>
            <vs-th class="w-1/12" style="min-width:100px" sort-key="title">부서명</vs-th>
            <vs-th class="w-1/12" style="min-width:100px" sort-key="title">작성자</vs-th>
            <vs-th class="w-1/12" style="min-width:100px" sort-key="title">계획일</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>{{tr.id}}</vs-td>
              <vs-td>{{getContent(tr).stdInfo.field_name}}</vs-td>
              <vs-td>{{getContent(tr).stdInfo.department}}</vs-td>
              <vs-td>{{getContent(tr).stdInfo.section}}</vs-td>
              <vs-td>{{getContent(tr).stdInfo.writer_name}}</vs-td>
              <vs-td>{{getContent(tr).stdInfo.date}}</vs-td>

            </vs-tr>
          </template>

        </vs-table>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination
              :total="(table.lastPage) ? table.lastPage : 1"
              :max-items="3"
              v-model="table.currentPage" @change="handleChangePage"></k-pagination>
          </div>
        </div>

      </div>
    </div>
  </vs-popup>
</template>


<script>

import KPagination from '@/components/kPagination/kPagination'
import SearchNavItemSelect from '@/components/nav/SearchNavItemSelect'
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
import SearchNavItemDate from '@/components/nav/SearchNavItemDate'
export default {
  name: 'PopupSafetyInspectionPlan',
  props: {
    popupActive: Boolean,
    size: String
  },
  components: {
    SearchNavItemDate,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    KPagination
  },
  data () {
    return {
      search : {
        dateType: '작성일',
        searchType: '시설물',
        searchKeyword: '',
        date: [],
      },
      table:{
        list:[],
        currentPage: 1,
        perPage: 10,
        lastPage: 1,
        total: 0,
      },
    }
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.popupActive
      },
      set () {
        this.handleCloseSelf()
      }
    },
    keywordTarget () {
      if (this.search.searchType === '시설물명') return 'content$body.stdInfo.field_name'
      if (this.search.searchType === '소속명') return 'content$body.stdInfo.department'
      if (this.search.searchType === '부서명') return 'content$body.stdInfo.section'
      if (this.search.searchType === '작성자') return 'content$body.stdInfo.writer_name'

      return ''
    }
  },
  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.popupActive) {
        this.handleCloseSelf()
        next(false); return
      }
      next(true)
    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })

    this.loadListBoard();
  },

  methods:{
    handleCloseSelf () {
      this.$emit('popupActiveSync', false)
    },
    handleSearch () {
      this.table.currentPage = 1;
      this.loadListBoard();
    },
    handleItemClickDetail (data) {
      this.$emit('handleItemClickDetail', data)
    },
    handleChangePage (page) {
      this.loadListBoard();
    },
    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },

    async loadListBoard() {
      const projectId = this.$route.params.proj_id
      const boardId = 137
      let dateTarget = 'created_at'
      if (this.search.dateType === '계획일') {
        dateTarget = 'content$body.stdInfo.date'
      }
      const dateBegin = this.search.date.length > 0 ? this.search.date[0] : `${new Date().getFullYear()}-01-01`
      const dateEnd = this.search.date.length > 1 ? this.search.date[1] : `${new Date().getFullYear()}-12-31`
      const keyword = [];
      if (this.keywordTarget) {
        keyword.push(`${this.keywordTarget}*%${this.search.searchKeyword}%`)
      }

      await this.$store.dispatch('board/LOAD_POST_LIST', {
        boardId,
        projectId,
        page: this.table.currentPage,
        perPage: this.table.perPage,
        keyword,
        dateTarget,
        dateBegin,
        dateEnd,
        orderTarget: 'created_at',
        orderDirection: 'desc',
      })
      const data = this.$store.state.board.postListInfo
      const rows = [...JSON.parse(JSON.stringify(this.$store.state.board.list))]
      this.table.lastPage = data.last_page
      this.table.total = data.total
      this.table.list = rows;
    },

  }
}

</script>


<style>

#popupSafetyInspectionPlan > .vs-popup {
  width:auto !important;
  min-width: 1200px !important;
  max-width:100% !important;
}
#popupSafetyInspectionPlan > .vs-popup > .vs-popup--content {
  width:100%;
  padding:0;
  margin:0;
}
#popupSafetyInspectionPlan > .vs-popup > .vs-popup--content > .vs-row{
  padding:24px;
}

</style>

<style scoped>
.head {
  display: flex;
}
</style>
